import React, { FC, ReactElement } from 'react'

type Props = {
    classNames?: string
    statuses: Nullable<string[]>
}

export const StatusOutput: FC<Props> = ({ classNames, statuses }: Props): ReactElement => (
    <div className={`status-output-container ${classNames}`}>
        <div className='status-output'>
            {statuses?.map(
                (status: string, index: number): ReactElement => (
                    <div className='status-entry' key={`${status}-status-${index}`}>
                        {status}
                    </div>
                )
            )}
            <div className='status-entry status-cursor'></div>
        </div>
    </div>
)
